var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("el-col", [
            _c("div", { staticClass: "main" }, [
              _c("div", { staticClass: "title-16 mb20" }, [_vm._v("考核评分")]),
              _vm._v(" "),
              _c("div", { staticClass: "v-height-flag" }, [
                _c(
                  "div",
                  {
                    staticClass: "input-suffix mb-14 pt-20",
                    staticStyle: { border: "none" },
                  },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.$t("access.scoretype")) + "："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: 1 },
                        model: {
                          value: _vm.radio,
                          callback: function ($$v) {
                            _vm.radio = $$v
                          },
                          expression: "radio",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("access.scoretype1")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: 0 },
                        model: {
                          value: _vm.radio,
                          callback: function ($$v) {
                            _vm.radio = $$v
                          },
                          expression: "radio",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("access.scoretype2")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-suffix" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v(_vm._s(_vm.$t("access.scoreshows")) + "："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        resize: "none",
                        autosize: "",
                        placeholder: _vm.$t("access.placeholder16"),
                      },
                      model: {
                        value: _vm.scoreMark,
                        callback: function ($$v) {
                          _vm.scoreMark = $$v
                        },
                        expression: "scoreMark",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "suffix-content v-height-flag" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.tableData },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: _vm.$t("access.classname"),
                            width: "130",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    staticStyle: { width: "130px" },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "access.placeholder17"
                                      ),
                                    },
                                    model: {
                                      value: scope.row.name,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "name", $$v)
                                      },
                                      expression: "scope.row.name",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("access.fractionalrange"),
                            width: "260",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "number-section" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "number-box" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.min)),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.$index > 0 ? "<" : "≤"
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("access.score"))
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("≤")]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("el-input-number", {
                                        staticClass: "ml14",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "access.inputthescore"
                                          ),
                                          controls: false,
                                          min: scope.row.min + 1,
                                          max: 10000,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.maxChange(scope.$index)
                                          },
                                        },
                                        model: {
                                          value: scope.row.max,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "max", $$v)
                                          },
                                          expression: "scope.row.max",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mark",
                            label: _vm.$t("access.levelthat"),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "number-explain" },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "367px" },
                                        attrs: {
                                          clearable: "",
                                          type: "text",
                                          placeholder:
                                            _vm.$t("access.levelthat"),
                                        },
                                        model: {
                                          value: scope.row.mark,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "mark", $$v)
                                          },
                                          expression: "scope.row.mark",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-delete",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelete(
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("public.delete"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "color189 add-btn" }, [
                  _c("span", { on: { click: _vm.addAssess } }, [
                    _vm._v("+" + _vm._s(_vm.$t("access.addarating"))),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cr-bottom-button" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", loading: _vm.loading },
              on: { click: _vm.handlePreserve },
            },
            [_vm._v(_vm._s(_vm.$t("public.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }